import { render } from "./ViewMoreVendor.vue?vue&type=template&id=16d24c41"
import script from "./ViewMoreVendor.vue?vue&type=script&lang=js"
export * from "./ViewMoreVendor.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__